module.exports = __webpack_public_path__ + "img/b7.80ea0d81.png";